import React, { Component } from 'react'
import AuthService from "../../services/AuthService";
import '../../css/BisharatMain.css';
import translate from '../../languages/translate';
export default class ActivateUser extends Component {

  state = {
    username : "",
    token : "",
    activatedSuccessfully : false,
    message : ""
  }



  componentDidMount() {
    this.refreshActivePage();
  }


  refreshActivePage = ()  => {
    const { match: { params } } = this.props;
    const username = params.username;
    const token = params.token;
    this.setState({
        username : username,
        token : token
    })
    
  
    }
  
    activateUserNow = (username,token) => {
    AuthService.activateUser(username,token)
    .then(res => {
      this.setState({
          activatedSuccessfully : true,
          message : res.data.message
      });
      AuthService.logout();
      window.location.href = `/`;
    },
    error => {
      this.setState({
          activatedSuccessfully: false,
          message: "Error",
        }); 
        window.location.href = `/activationerror`;
    }
    )
}

  render() {

    return (
        <div className="activate-user-wrap">
<div className="button-activate-user">
  <p> {translate("click-to-activate")}</p>
    <button onClick={() => this.activateUserNow(this.state.username,this.state.token)}>Activate Now</button>
</div>
<div className="activate-user-error">
    {this.state.activatedSuccessfully ? <div> <p>{translate("activated")}</p>

        </div> : <div>
         <p>{this.state.message}</p>
        </div>
    }
    </div>
    </div>
    )
  }
}
